import React, { useState, useEffect } from 'react';
import apiClient from '../../../Api/axiosConfig'; // Az axios klienst használjuk
import './AnalyticsPage.css'; // Szükség lesz egy CSS fájlra

const AnalyticsPage = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setIsLoading(true);
    apiClient.get('/analytics/events')
      .then(response => {
        setEvents(response.data);
      })
      .catch(() => {
        setError('Hiba az analitikai adatok betöltésekor.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) return <div>Analitikai adatok betöltése...</div>;
  if (error) return <div className="dashboard-error">{error}</div>;

  return (
    <div>
      <div className="admin-page-header">
        <h1>Analitika</h1>
        <span className="event-count">Összesen {events.length} esemény rögzítve</span>
      </div>
      <div className='editor-card'>
        <div className="table-wrapper">
            <table className="analytics-table">
            <thead>
                <tr>
                <th>Időbélyeg</th>
                <th>Esemény Típusa</th>
                <th>Anonimizált User ID</th>
                <th>Részletek</th>
                <th>Böngésző</th>
                </tr>
            </thead>
            <tbody>
                {[...events].reverse().map((event, index) => (
                <tr key={`${event.timestamp}-${index}`}>
                    <td>{new Date(event.timestamp).toLocaleString()}</td>
                    <td><span className={`event-badge event-${event.eventType}`}>{event.eventType}</span></td>
                    <td className="userid-cell" title={event.userId}>{event.userId.substring(0, 12)}...</td>
                    <td className="details-cell">{JSON.stringify(event.details)}</td>
                    <td className="useragent-cell" title={event.userAgent}>{event.userAgent.substring(0, 40)}...</td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPage;